// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._v5641hrg{transition:opacity .2s ease}._152tv77o{inset-block-start:var(--ds-space-025,2px)}\n._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1bsbgktf{width:20px}\n._1e021l7b{inset-inline-start:3px}\n._1e0c116y{display:inline-flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._4t3igktf{height:20px}\n._kqswstnw{position:absolute}\n._rjxp1l7b{inset-inline-end:3px}\n._tzy4idpf{opacity:0}", ""]);
// Exports
module.exports = exports;
